import { callPlanet } from './'

// type FetchReviews = (HotelMapInfo, string, string) => AjaxObservable
export const fetchReviews = (latitude, longitude, locationId, countryCode, cultureCode) => {
  return callPlanet((locationId)
    ? `comments/${locationId}/${cultureCode}/${countryCode}`
    : `comments/coords/${latitude}/${longitude}/${cultureCode}/${countryCode}`)
}
